/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Automation/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromFlow from 'Simple/Flow'
import * as fromHelpers from './helpers.js'
import AppointmentBookingStateUpdate from './AppointmentBookingStateUpdate/index'
import No from './No/index'
import React from 'react'
import ResourceInsert from './ResourceInsert/index'
import TreatmentStatusUpdate from './TreatmentStatusUpdate/index'



/** @type {import('Simple/types.js').View} */
export default function Automation({
  children,
  viewPath = "/App/Account/Content/Settings/Content/ConnectApps/App/Content/Connections/Content/ActionsColumn/ToggleLocationConnection/SetupAutomations/Content/Content/Content/Steps/Content/ActiveStep/Automation"
  
}) {
  let flowValue = fromFlow.useFlowValue(viewPath) || 'No'
let selectedEventTypeValueData = fromData.useDataFormat({ viewPath,
context: 'selected',
path: 'event.type',
format: fromHelpers.getView,
})
fromData.useSetFlowToBasedOnDataValue({ viewPath,
value: selectedEventTypeValueData,
})
  return (<React.Fragment
>
<fromFlow.When is={flowValue === 'No'}>
<No
  viewPath={`${viewPath}/No`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'AppointmentBookingStateUpdate'}>
<AppointmentBookingStateUpdate
  viewPath={`${viewPath}/AppointmentBookingStateUpdate`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'TreatmentStatusUpdate'}>
<TreatmentStatusUpdate
  viewPath={`${viewPath}/TreatmentStatusUpdate`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'ResourceInsert'}>
<ResourceInsert
  viewPath={`${viewPath}/ResourceInsert`}
/>
</fromFlow.When>
{children}
</React.Fragment>)
}